import type { LogoProps } from '@/components/header/components/logo/logo.types';
import { useWindowSize } from 'usehooks-ts';
import clsx from 'clsx';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import Condition from '@/utils/condition';
import '@/components/header/components/logo/logo.css';

export default function Logo(props: LogoProps) {
  const logo = useAppSelector(GeneralSlice.selectors.logo);
  const selectedKeyword = useAppSelector(ConfigSlice.selectors.selectedKeyword);
  const { width } = useWindowSize();

  const useRightmart = Condition.keyInQueryParamsOrCookiesEqual('rightmart', 'true') && logo.rightmart;
  const src = useRightmart ? logo.rightmart : width >= 768 ? logo.desktop : logo.mobile;
  const alt = useRightmart ? 'LFLogoRightmart' : width >= 768 ? 'LFLogoImage' : 'LFLogoImageMobile';

  if (!src) return null;

  return (
    <button className='header-logo' type='button' aria-label='header-logo' onClick={() => props.onClick()}>
      <img
        title={selectedKeyword}
        className={clsx('header-logo__icon', { 'header-logo__icon--rightmart': useRightmart })}
        src={src}
        alt={alt}
      />
    </button>
  );
}
